<mat-table [dataSource]="dataSource" matSort [matSortActive]="matSortActive" [matSortDirection]="matSortDirection"
    matSortDisableClear class="w-100">
    <ng-container *ngFor="let item of tableKeys; let first = first; let last = last">
        <ng-container matColumnDef="{{item.key}}">

            <!-- TABLE HEADER -->
            <mat-header-cell [ngStyle]="getWidth(item.width)" *matHeaderCellDef mat-sort-header
                [disabled]="item.sortable? !item.sortable : true">
                <ng-container [ngSwitch]="item.type">
                    <ng-container *ngSwitchCase="'CHECKBOX'">
                        <mat-checkbox [checked]="allCheckboxesSelected" (change)="selectAllCheckboxes()"
                            (click)="$event.stopPropagation()"></mat-checkbox>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        {{item.label}}
                    </ng-container>
                </ng-container>
            </mat-header-cell>

            <!-- TABLE CELL -->
            <mat-cell [ngStyle]="getWidth(item.width)" [class]="element?.css" *matCellDef="let element">
                <ng-container [ngSwitch]="item.type">
                    <!-- CHECKBOX -->
                    <ng-container *ngSwitchCase="'CHECKBOX'">
                        <mat-checkbox [checked]="checkboxIsSelected(element)" (change)="onCheckboxChange(element)"
                            (click)="$event.stopPropagation()" [disabled]="element.isDisabled || false"></mat-checkbox>
                    </ng-container>
                    <!-- CHECKBOX -->
                    <ng-container *ngSwitchCase="'RADIO'">
                      <mat-radio-button
                        [value]="element.id"
                        (change)="selectItem(element)"
                        (click)="$event.stopPropagation()"
                        [checked]="radioSelectionGroup === element.id"
                        name="rowSelection"
                      >
                      </mat-radio-button>
                    </ng-container>
                    <!-- DOT_MENU -->
                    <ng-container *ngSwitchCase="'DOT_MENU'">
                        <div class="w-100 d-flex justify-content-center">
                            <!--
                            TODO
                             <app-basic-dotmenu [dotMenuItems]="item.dotMenuOptions"
                                (buttonClicked)="onButtonClick($event, element)"></app-basic-dotmenu>
                                -->
                        </div>
                    </ng-container>
                    <!-- ACTION_ICON -->
                    <ng-container *ngSwitchCase="'ACTION_ICON'">
                        <ng-container *ngIf="element?.showIcon">
                            <mat-icon class="table-action-icon align-middle" [color]="item?.color"
                                (click)="onButtonClick(item.key, element); $event.stopPropagation()">{{item?.actionIcon}}</mat-icon>
                        </ng-container>
                    </ng-container>
                    <!-- IMAGE -->
                    <ng-container *ngSwitchCase="'IMAGE'">
                        <img [src]="getCompanyImage(element)" alt="company-logo" class="company-logo-img">
                    </ng-container>
                    <!-- BADGE -->
                    <ng-container *ngSwitchCase="'BADGE'">
                        <span class="badge" [ngClass]="getStatusBadge(element)">
                            {{getStatusLabel(element)}}
                        </span>
                    </ng-container>
                    <!-- CURRENCY -->
                    <ng-container *ngSwitchCase="'CURRENCY'">
                        {{element[item.key] | currency: 'EUR'}}
                    </ng-container>
                    <!-- TOOLTIP -->
                    <ng-container *ngSwitchCase="'TOOLTIP'">
                        <span matTooltip="{{element[item.key]}}" matTooltipPosition="above" class="cell-ellipsis"> {{element[item.key]}} </span>
                    </ng-container>
                    <!-- DEFAULT CELL -->
                    <ng-container *ngSwitchDefault>
                        <span>{{ getValueByPath(element, item) }}</span>
                    </ng-container>
                </ng-container>
            </mat-cell>

        </ng-container>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

    <mat-row *matRowDef="let element; let row; columns: displayedColumns;" matRipple class="element-row"
        (click)="onRowClick(row)"></mat-row>

</mat-table>
<mat-paginator [length]="dataSource.length" [pageSize]="tableConstants.PAGE_SIZE"
    [pageSizeOptions]="tableConstants.PAGE_SIZE_OPTIONS">
</mat-paginator>
